import type { CSSProperties, ReactNode } from "react";

import { cn } from "../lib/cn";

function Skeleton({
  className,
  w,
  h,
  rounded,
  style,
  ...props
}: React.ComponentProps<"div"> & {
  w?: number | string;
  h?: number | string;
  rounded?: boolean;
}) {
  const dimensions: CSSProperties = { width: w, height: h, ...style };

  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn(
        "rounded-md [animation:var(--ui-skeleton-animation,var(--animate-pulse))] [background:var(--ui-skeleton-background,var(--color-accent))]",
        rounded && "rounded-full",
        className,
      )}
      style={dimensions}
      {...props}
    />
  );
}

function SkeletonRegion({
  label = "Loading",
  children,
}: {
  label?: string;
  children: ReactNode;
}) {
  return (
    <div role="status" aria-busy="true" aria-label={label}>
      {children}
    </div>
  );
}

export { Skeleton, SkeletonRegion };
